import { Outlet, useOutletContext } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { DetailOutletContext } from '../types'

const ClassesIndexPage = () => {
  const { classes, training, canEdit, hasDevTrainings } = useOutletContext<DetailOutletContext>()
  return (
    <ResponsivePage.Body showHeader={false}>
      <Outlet context={{ classes, training, canEdit, hasDevTrainings }} />
    </ResponsivePage.Body>
  )
}

export default ClassesIndexPage
